import React, { useState, useEffect, ReactElement } from 'react';
import styled from '@emotion/styled';
import { getColor } from '../../style';
import ArrowUpwardRoundedIcon from '@material-ui/icons/ArrowUpwardRounded';
import useMediaBreakpoints from '../../hooks/useMediaBreakpoints';
import breakpoints from '../../theme/material/breakpoints';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const BackToTopDesktop = styled('span')(() => ({
  fontSize: 16,
  color: getColor().BRAND_1,
  fontWeight: 600,
  position: 'fixed',
  width: '100%',
  left: 0,
  bottom: 10,
  zIndex: 99,
  [breakpoints.down('sm')]: {
    fontSize: 46,
    color: '#FFF',
    width: '25%',
    left: '75%',
    bottom: 110,
  },
}));

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const BackToTopText = styled('div')(() => ({
  backgroundColor: '#FFF',
  cursor: 'pointer',
  width: 120,
  padding: '5px 5px 8px 5px',
  borderRadius: 4,
  opacity: 0.8,
  margin: '0 auto',
  textAlign: 'center',
  float: 'unset',
  [breakpoints.down('sm')]: {
    backgroundColor: '#E21D4A',
    padding: '5px 4px 0px 4px',
    width: 55,
    borderRadius: '50%',
    opacity: 1,
    margin: '0 20px',
    float: 'right',
  },
}));

interface BackToTopContainerProps {
  onClick: any;
  isVisible: boolean;
}

const BackToTopContainer = ({ onClick, isVisible = false }: BackToTopContainerProps): ReactElement => {
  const { isMobile } = useMediaBreakpoints();
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    const position = window.pageYOffset;

    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (!isVisible && !isMobile) return null;

  if (scrollPosition < 300) return null;

  return (
    <BackToTopDesktop data-test-id="back-to-top-desktop">
      <BackToTopText onClick={onClick}>
        <ArrowUpwardRoundedIcon style={{ fontSize: isMobile ? 46 : 16 }} />
        {!isMobile && ' Back to top'}
      </BackToTopText>
    </BackToTopDesktop>
  );
};

export default BackToTopContainer;
